import { updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

const initialState = {
  loading: false,
  error: false,
  submitted: false,
  importantPlaces: [],
};

const addImportantPlaceStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: false,
    submitted: false,
  });
};

const addImportantPlaceSuccess = (state) => {
  return updateObject(state, {
    loading: false,
    error: false,
    submitted: true,
  });
};

const addImportantPlaceFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    submitted: false,
  });
};

const updateImportantPlaceStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: false,
    submitted: false,
  });
};

const updateImportantPlaceSuccess = (state) => {
  return updateObject(state, {
    loading: false,
    error: false,
    submitted: true,
  });
};

const updateImportantPlaceFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    submitted: false,
  });
};

const fetchImportantPlacesStart = (state) => {
  return updateObject(state, {
    loading: true,
    error: false,
    importantPlaces: [],
  });
};

const fetchImportantPlacesSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    importantPlaces: action.importantPlaces,
  });
};

const fetchImportantPlacesFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_IMPORTANT_PLACE_START:
      return addImportantPlaceStart(state, action);
    case actionTypes.ADD_IMPORTANT_PLACE_SUCCESS:
      return addImportantPlaceSuccess(state, action);
    case actionTypes.ADD_IMPORTANT_PLACE_FAILED:
      return addImportantPlaceFailed(state, action);
    case actionTypes.UPDATE_IMPORTANT_PLACE_START:
      return updateImportantPlaceStart(state, action);
    case actionTypes.UPDATE_IMPORTANT_PLACE_SUCCESS:
      return updateImportantPlaceSuccess(state, action);
    case actionTypes.UPDATE_IMPORTANT_PLACE_FAILED:
      return updateImportantPlaceFailed(state, action);
    case actionTypes.FETCH_IMPORTANT_PLACES_START:
      return fetchImportantPlacesStart(state, action);
    case actionTypes.FETCH_IMPORTANT_PLACES_SUCCESS:
      return fetchImportantPlacesSuccess(state, action);
    case actionTypes.FETCH_IMPORTANT_PLACES_FAILED:
      return fetchImportantPlacesFailed(state, action);
    default:
      return state;
  }
};
export default reducer;
